export default __webpack_public_path__ + "static/media/047-warning.71b06319.png";